import {FETCH_LEFTMENU_BEGIN,FETCH_LEFTMENU_SUCCESS,FETCH_LEFTMENU_FAILURE} from '../constants/leftmenu';

const initialState={
    leftMenuItems:[],
    isLoading:false,
    error:""
}


export const getLeftMenuReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_LEFTMENU_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
      case FETCH_LEFTMENU_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            leftMenuItems:payload.leftMenuItemData
        };
    case FETCH_LEFTMENU_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getLeftMenuReducer
